import { hideSidebar, Sidebar } from '@components/sidebar';
import { useScopedTranslate } from '@locale/translate';

import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { ACTION_TYPES } from 'ui/actions/action-config';
import {
  ActionHeader,
  ActionSidebarLoading,
  SidebarProps,
} from 'ui/journey-builder/node-types/common';

import { ConditionFormContent } from '../condition/helpers';

const ACTION_TYPE = ACTION_TYPES.break_loop;

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const { t } = useScopedTranslate(sidebarLocale);

  const editMutation = useUpdateJourneyAction(journeyActionId);

  const { data, isLoading } = useJourneyAction<typeof ACTION_TYPE>(journeyActionId);
  const values = data?.values;

  if (isLoading || !data) {
    return <ActionSidebarLoading actionType={ACTION_TYPE} {...props} />;
  }

  return (
    <Sidebar>
      <ActionHeader actionType={ACTION_TYPE} {...props} />
      <Sidebar.Content>
        <ConditionFormContent
          action={data}
          onCancel={hideSidebar}
          journeyId={data.journey}
          conditionDescription={t('breakLoop')}
          hideActionButtons
          onSubmit={(data) =>
            editMutation.mutateAsync({
              isAutomatic: true,
              action: ACTION_TYPE,
              values: {
                loopAction: values?.loopAction,
                ...data,
              },
            })
          }
        />
      </Sidebar.Content>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    breakLoop: 'Exit loop',
  },
};
